











import Vue from "vue";
import UserAvatar from "@/components/buttons/UserAvatar.vue";
import UserMenu from "@/components/menus/user-menu/UserMenu.vue";
import ZenyaDialog from "@/components/dialogs/ZenyaDialog.vue";
import storeHelper from "@/store/store-helper";
import PrivacyPolicy from "./PrivacyPolicy.vue";
export default Vue.extend({
    name: "ToolbarUser",
    components: {
        UserAvatar,
        UserMenu,
        ZenyaDialog,
        PrivacyPolicy
    },
    props: {
        isAnonymousUser: Boolean,
        portalId: Number
    },
    data: () => {
        return {
            showPrivacyPolicyDialog: false
        };
    },
    watch: {
        showPrivacyPolicyDialog: function (newValue: boolean) {
            storeHelper.siteStore.setIsDialogDisplayed(newValue);
        }
    },
    computed: {
        userFullName(): string {
            return this.$user?.name;
        }
    },
    methods: {
        openPrivacy() {
            this.showPrivacyPolicyDialog = true;
        }
    }
});
